var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('div',{staticClass:"list-item-row d-flex"},[_c('div',{staticClass:"list-column email"},[_vm._v(_vm._s(_vm.user.email))]),_c('div',{staticClass:"list-column date"},[_vm._v(" "+_vm._s(_vm.createdAt)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }